// src/components/common/PageHeader.js

import { Grid, Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";

const PageHeader = ({
    title,
    backTo,
    backText = "Volver"
}) => {
    return (
        <Grid container spacing={0}>
            <Grid item xs={8} sm={8}>
                <Typography variant="h5" component="span">
                    <Box sx={{ fontWeight: "bold" }}>
                        {title}
                    </Box>
                </Typography>
            </Grid>

            {backTo && (
                <Grid item xs={4} sm={4}>
                    <Box textAlign="right">
                        <Link to={backTo}>
                            {backText}
                        </Link>
                    </Box>
                </Grid>
            )}
        </Grid>
    );
};

export default PageHeader;
